import * as React from "react";
const SvgFiRrCallDuration = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-call-duration_svg__a)">
      <path
        fill="#062147"
        d="M18 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6m0-10c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m-.707 4.707A1 1 0 0 1 17 6V4a1 1 0 0 1 2 0v1.586l.707.707a.999.999 0 1 1-1.414 1.414zm3.363 8.149a3.1 3.1 0 0 0-4.282.006l-1.464 1.165c-3.198-1.357-5.474-3.637-6.932-6.946l1.159-1.456A3.07 3.07 0 0 0 10 5.48c0-.807-.304-1.559-.857-2.138 0 0-1.852-2.406-1.883-2.437a3.07 3.07 0 0 0-2.188-.907c-.826 0-1.604.322-2.138.859l-1.15 1.004C.633 3.012 0 4.565 0 6.238 0 13.874 10.126 24 17.762 24a6.15 6.15 0 0 0 4.42-1.833l.911-1.05a3.1 3.1 0 0 0 0-4.378c-.031-.031-2.437-1.883-2.437-1.883m.977 4.896-.912 1.051c-.77.771-1.82 1.196-2.958 1.196-5.989 0-15.762-8.806-15.762-15.762 0-1.138.425-2.189 1.147-2.913l1.151-1.005c.207-.207.481-.321.774-.321.274 0 .533.1.734.283 0 0 1.842 2.394 1.873 2.424.207.207.321.482.321.774s-.114.567-.321.774a540 540 0 0 0-1.635 2.045 1 1 0 0 0-.146.995c1.713 4.267 4.681 7.232 8.822 8.812.33.124.702.068.979-.152 0 0 2.018-1.607 2.044-1.634a1.094 1.094 0 0 1 1.55 0c.03.03 2.423 1.872 2.423 1.872.389.43.375 1.097-.084 1.56z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-call-duration_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCallDuration;
